import React from 'react';
import { useAuth } from '../context/AuthContext.js';
import './LoginPage.css';

const LoginPage = () => {
  const { signIn, loading } = useAuth();
  
  // Check if we're on localhost (development mode)
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1';

  if (loading) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Admin Access</h1>
          {isLocalhost ? (
            <p>Development mode: Click below to access the admin panel</p>
          ) : (
            <p>Sign in with your Google account to access the admin panel</p>
          )}
        </div>
        
        <div className="login-content">
          <div className="google-signin-button" onClick={signIn}>
            {isLocalhost ? (
              <>
                <div className="google-icon">
                  <i className="fas fa-code"></i>
                </div>
                <span>Access Admin Panel (Development)</span>
              </>
            ) : (
              <>
                <div className="google-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                </div>
                <span>Sign in with Google</span>
              </>
            )}
          </div>
          
          <div className="login-info">
            {isLocalhost ? (
              <p className="security-note">
                <i className="fas fa-code"></i>
                Development mode: OAuth is disabled for localhost. Click above to access the admin panel.
              </p>
            ) : (
              <>
                <p className="security-note">
                  <i className="fas fa-shield-alt"></i>
                  This admin panel is protected and only accessible to authorized users.
                </p>
                
                <div className="troubleshooting-info">
                  <details>
                    <summary>Having trouble signing in?</summary>
                    <div className="troubleshooting-content">
                      <p><strong>Common issues:</strong></p>
                      <ul>
                        <li>Make sure your domain is authorized in Google Cloud Console</li>
                        <li>Check that your email is set correctly in the configuration</li>
                        <li>Try refreshing the page or using incognito mode</li>
                        <li>See <code>OAUTH_TROUBLESHOOTING.md</code> for detailed help</li>
                      </ul>
                    </div>
                  </details>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
